module.exports = __webpack_public_path__ + "img/banner.c9a09e1d.png";